import { BfxBlotterAction } from "shared/cubiq-services";
import {
  BfxBaseBlotterContextMenuService,
  BfxBlotterActionEvent,
} from "./bfx-base-blotter-contextmenu.service";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { TranslateService } from "@ngx-translate/core";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";

import { LoggerService } from "@bfx/logger";
import { Subscription } from "rxjs";
const logger = LoggerService.for(__dirname);

/**
 * Decorators are subject to this bug:
 * https://github.com/Microsoft/TypeScript/issues/14082
 *
 * Don't apply in base class
 */
export function ActionListener(action: BfxBlotterAction) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    if (descriptor === undefined) {
      descriptor = Object.getOwnPropertyDescriptor(target, propertyKey);
    }

    var originalMethod = descriptor.value;

    target.registerActionListener(action, originalMethod);

    return descriptor;
  };
}

/**
 * Override to implement specific actions for specific blotter
 *
 * note abstract classes are not injectable
 */
export abstract class BfxBaseBlotterActionService<T> {
  public actionListeners: any;
  protected actionSubscription: Subscription;

  constructor(
    protected contextMenuService: BfxBaseBlotterContextMenuService<T>,
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    protected configService: BfxConfigService,
  ) {
    this.initialize();
  }

  /**
   * override to return the audit window type, this might not be applicable to all blotters,
   * so we could potentially move this out of the abstract and move it into quotes and orders action services
   */
  //protected abstract getAuditType():DashboardItemType;

  protected initialize(): void {
    this.actionSubscription = this.contextMenuService.actionSubject.subscribe(
      this.handleActionEvent.bind(this),
    );
  }

  public registerActionListener(action: BfxBlotterAction, callback) {
    if (!this.actionListeners) {
      this.actionListeners = {};
    }

    let listeners: Array<any> = this.actionListeners[action];

    if (!listeners) {
      this.actionListeners[action] = listeners = [];
    }

    listeners.push(callback);
  }

  protected handleActionEvent(event: BfxBlotterActionEvent) {
    let listeners: Array<any> = this.actionListeners[event.action];

    if (listeners && listeners.length > 0) {
      try {
        listeners.forEach((callback) => callback.call(this, event));
      } catch (error) {
        logger.out.info(error);
      }
    }
  }
}
